import { Link } from "react-router-dom";
import { Envelope, Phone, MapPin, LinkedinLogo, TwitterLogo } from "@phosphor-icons/react";

const LOGO_URL = "/logo.png";

const quickLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/journals", label: "Journals" },
  { href: "/submit-manuscript", label: "Submit Manuscript" },
];

const resourceLinks = [
  { href: "/editorial-board", label: "Editorial Board" },
  { href: "/contact", label: "Contact Us" },
  { href: "#", label: "Author Guidelines" },
  { href: "#", label: "Publication Ethics" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 bg-white px-4 py-2 rounded-sm shadow-xs">
              <img
                src={LOGO_URL}
                alt="iScience Publishers"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed mb-6">
              iScience Publishers is dedicated to advancing scientific and medical 
              research through rigorous peer-reviewed publications.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                data-testid="social-linkedin"
                className="w-10 h-10 rounded-sm bg-[#1E293B] flex items-center justify-center text-[#94A3B8] hover:bg-[#0D9488] hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <LinkedinLogo size={20} weight="fill" />
              </a>
              <a
                href="#"
                data-testid="social-twitter"
                className="w-10 h-10 rounded-sm bg-[#1E293B] flex items-center justify-center text-[#94A3B8] hover:bg-[#0D9488] hover:text-white transition-colors"
                aria-label="Twitter"
              >
                <TwitterLogo size={20} weight="fill" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Chivo']">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#0D9488] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Chivo']">Resources</h4>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#0D9488] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Chivo']">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#0D9488] flex-shrink-0 mt-0.5" weight="fill" />
                <span className="text-[#94A3B8] text-sm">
                  iScience Publishers LLC<br />
                  264 E Honeysuckle Pl, Chandler,<br />
                  Arizona, 85286, USA
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Envelope size={20} className="text-[#0D9488] flex-shrink-0 mt-0.5" weight="fill" />
                <div className="flex flex-col gap-1">
                  <a href="mailto:info@iscienceqpublishers.com" className="text-[#94A3B8] hover:text-[#0D9488] text-sm transition-colors">
                    info@iscienceqpublishers.com
                  </a>
                  <a href="mailto:isciencepublishers@gmail.com" className="text-[#94A3B8] hover:text-[#0D9488] text-sm transition-colors">
                    isciencepublishers@gmail.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-[#64748B] text-sm">
              © {new Date().getFullYear()} iScience Publishers. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-[#64748B] hover:text-[#94A3B8] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-[#64748B] hover:text-[#94A3B8] text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
